import axios from 'axios';
import Toast from './../../config/toast'
import {loaderActions  } from '../common/action';
import { LIST_APPS,END_URL,TYPE,VALIDATION,LIST_ADVERTISERS } from './config';
import { API_URL } from '../../config/globals';

axios.interceptors.request.use(
    function (config) {       
      const token = JSON.parse(localStorage.getItem("auth")) ? JSON.parse(localStorage.getItem("auth")).token : null;
      if (token) {
        config.headers["authorization"] = token;
      }
  
      return config;
    },
    function (error) {
      return Promise.reject(error);
    }
  );

export const getApplications = (id) => {
    return (dispatch, getState) => {
        dispatch(loaderActions(true))
        const url = id ? `${API_URL}${END_URL.APPLICATION}?id=${id}` : `${API_URL}${END_URL.APPLICATION}`;
        axios.get(url).then(function (response) {
          
            if (response.status) {
                dispatch(
                    {
                        type: LIST_APPS,
                        payload: response.data
                    });
                    dispatch(loaderActions(false))
            }
        }).catch(err => {

            const msg = (err.response && err.response.data) ?
                err.response.data.message : VALIDATION.SYSTEM_ERROR
            Toast(msg, TYPE.ERROR)
            dispatch(loaderActions(false))
        });
    };
}

export const getAdvertisers = (id) => {
    return (dispatch, getState) => {
        dispatch(loaderActions(true))
        const url = id ? `${id}/${END_URL.ADVERTISERS}` : `${END_URL.ADVERTISERS}`;
        axios.get(url).then(function (response) {
            if (response.status) {
                dispatch(
                    {
                        type: LIST_ADVERTISERS,
                        payload: response.data
                    });
                    dispatch(loaderActions(false))
            }
        }).catch(err => {

            const msg = (err.response && err.response.data) ?
                err.response.data.message : VALIDATION.SYSTEM_ERROR
            Toast(msg, TYPE.ERROR)
            dispatch(loaderActions(false))
        });
    };
}